import type { ContextualCommentResource, ReportComponent } from '@/types';

export interface ReportComponentCommentResourceContext extends ContextualCommentResource {
    component?: string;
    metadata?: Record<string, unknown>;
}

export const reportComponentTitle = (component: ReportComponent) =>
    component.name || component.type || 'Report Component';

/** Keeps comment identity component-scoped while linking through its parent report canvas. */
export const getReportComponentCommentResource = (
    component: ReportComponent,
    fallbackDashboardId?: string,
): ReportComponentCommentResourceContext => {
    const dashboardId = component.report?.dashboard?.id ?? fallbackDashboardId;
    const reportId = component.report?.id;

    return {
        component: `reportComponent:${component.id}`,
        resourceHref: dashboardId && reportId ? `/dashboards/${dashboardId}?report=${reportId}` : undefined,
        resourceId: component.id,
        resourceTitle: reportComponentTitle(component),
        resourceType: 'reportComponents',
    };
};
